import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appEmbedData = { image: '_media' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _badgeList = { badges: '_v3Badge' };
var _bulkCancelEventsByFilterRequest = {};
var _bulkCancelEventsByFilterResponse = {};
var _bulkDeleteEventsByFilterRequest = {};
var _bulkDeleteEventsByFilterResponse = {};
var _cancelEventRequest = {};
var _cancelEventResponse = { event: '_event' };
var _cloneEventRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    event: '_event',
};
var _cloneEventResponse = { event: '_event' };
var _commonAddress = { geocode: '_commonAddressLocation' };
var _commonAddressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _countEventsByStatusRequest = {};
var _countEventsByStatusResponse = {};
var _createEventRequest = { event: '_event' };
var _createEventResponse = { event: '_event' };
var _dateAndTimeSettings = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
    recurringEvents: '_recurrences',
};
var _deleteEventRequest = {};
var _deleteEventResponse = {};
var _design = { poll: '_pollDesign' };
var _event = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    publishedDate: 'google.protobuf.Timestamp',
    location: '_location',
    dateAndTimeSettings: '_dateAndTimeSettings',
    mainImage: '_image',
    registration: '_registration',
    categories: '_eventCategories',
    description: '_richContent',
    badges: '_badgeList',
};
var _eventCategories = { categories: '_eventCategory' };
var _eventCategory = { createdDate: 'google.protobuf.Timestamp' };
var _findEventRequest = {};
var _findEventResponse = { event: '_event' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getEventBySlugRequest = {};
var _getEventBySlugResponse = { event: '_event' };
var _getEventRequest = {};
var _getEventResponse = { event: '_event' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _imageData = { image: '_media' };
var _item = { image: '_itemImage', video: '_video' };
var _itemImage = { media: '_media' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _listEventsByCategoryRequest = {};
var _listEventsByCategoryResponse = { events: '_event' };
var _location = { address: '_commonAddress' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _occurrence = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _publishDraftEventRequest = {};
var _publishDraftEventResponse = { event: '_event' };
var _queryEventsRequest = {};
var _queryEventsResponse = { events: '_event' };
var _recurrences = { individualEventDates: '_occurrence' };
var _registration = { rsvp: '_rsvpRegistration' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _rsvpRegistration = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _updateEventRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    event: '_event',
};
var _updateEventResponse = { event: '_event' };
var _v3Badge = { functionUpdateDate: 'google.protobuf.Timestamp' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
function resolveWixEventsEventsV3EventManagementUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/events/v3/events',
                destPath: '/v3/events',
            },
            {
                srcPath: '/events/v3/bulk/events',
                destPath: '/v3/bulk/events',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/events-events-v3-adapter',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-events-v3-adapter',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/events-events-v3-adapter',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/events-events-v3-adapter',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/events-events-v3-adapter',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/events-events-v3-adapter',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/events-events-v3-adapter',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/events-events-v3-adapter',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates an event. <br> <br>
 * The event includes a default registration form in the selected language, which consists of input fields for first name, last name, and email. See the Registration Form API ([SDK](https://dev.wix.com/docs/sdk/backend-modules/events/forms/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/events/form/about-the-registration-form-api)) for more information. <br> <br>
 * You can create the event as a draft by setting `draft` to `true`. Otherwise, the event is published right away. <br> <br>
 * The event is automatically set up to send daily summary reports of new guests to your business email.
 */
export function createEvent(payload) {
    var _a = serializer(_createEventRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createEventResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __createEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'POST',
            methodFqn: 'wix.events.events.v3.EventManagement.CreateEvent',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createEvent.fromReq = fromReq;
    __createEvent.__isAmbassador = true;
    return __createEvent;
}
/**
 * Clones an event, including the registration form, notifications, multilingual translations and ticket configuration from the original event. <br> <br>
 * The new event's date is automatically set to 14 days from the original event date. <br> <br>
 * If an event with the same `title` already exists, the new event's `title` gets a sequence number. For example, if you clone an event named `"Leather Crafting 101"`, the new event's title is `"Leather Crafting 101 (1)"`. <br> <br>
 * You can change the required entity field values while cloning an event.
 */
export function cloneEvent(payload) {
    var _a = serializer(_cloneEventRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneEventResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __cloneEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'POST',
            methodFqn: 'wix.events.events.v3.EventManagement.CloneEvent',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/{eventId}/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneEvent.fromReq = fromReq;
    __cloneEvent.__isAmbassador = true;
    return __cloneEvent;
}
/** Updates an event. */
export function updateEvent(payload) {
    var _a = serializer(_updateEventRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateEventResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __updateEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'PATCH',
            methodFqn: 'wix.events.events.v3.EventManagement.UpdateEvent',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/{event.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateEvent.fromReq = fromReq;
    __updateEvent.__isAmbassador = true;
    return __updateEvent;
}
/**
 * Publishes a draft event to your live site. Once published, the event's status changes from `"DRAFT"` to `"UPCOMING"`. <br> <br>
 * It's impossible to revert the `"DRAFT"` status after publishing. The only option is to clone the event, then delete the original.
 */
export function publishDraftEvent(payload) {
    var _a = serializer(_publishDraftEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishDraftEventResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __publishDraftEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'POST',
            methodFqn: 'wix.events.events.v3.EventManagement.PublishDraftEvent',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/{eventId}/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishDraftEvent.fromReq = fromReq;
    __publishDraftEvent.__isAmbassador = true;
    return __publishDraftEvent;
}
/**
 * Cancels an event. <br> <br>
 * After cancellation, registration for an event is closed. To reuse the event, call Clone Event and Publish Event to publish it again. <br> <br>
 * If event cancellation notifications are enabled, canceling an event automatically triggers the sending of cancellation emails and/or push notifications to registered guests.
 */
export function cancelEvent(payload) {
    var _a = serializer(_cancelEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelEventResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __cancelEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'POST',
            methodFqn: 'wix.events.events.v3.EventManagement.CancelEvent',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/{eventId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelEvent.fromReq = fromReq;
    __cancelEvent.__isAmbassador = true;
    return __cancelEvent;
}
/**
 * Cancels multiple events that meet the specified criteria. <br> <br>
 * After cancellation, registration for an event is closed. To reuse the event, call Clone Event and Publish Event to publish it again. <br> <br>
 * If event cancellation notifications are enabled, canceling an event automatically triggers the sending of cancellation emails and/or push notifications to registered guests.
 */
export function bulkCancelEventsByFilter(payload) {
    var _a = serializer(_bulkCancelEventsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCancelEventsByFilterResponse, {}).fromJSON;
    function __bulkCancelEventsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'POST',
            methodFqn: 'wix.events.events.v3.EventManagement.BulkCancelEventsByFilter',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/bulk/events/cancel-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCancelEventsByFilter.fromReq = fromReq;
    __bulkCancelEventsByFilter.__isAmbassador = true;
    return __bulkCancelEventsByFilter;
}
/**
 * Deletes an event. <br> <br>
 * You can retrieve the deleted event through a GDPR access request.
 */
export function deleteEvent(payload) {
    var _a = serializer(_deleteEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteEventResponse, {}).fromJSON;
    function __deleteEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'DELETE',
            methodFqn: 'wix.events.events.v3.EventManagement.DeleteEvent',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/{eventId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteEvent.fromReq = fromReq;
    __deleteEvent.__isAmbassador = true;
    return __deleteEvent;
}
/**
 * Deletes multiple events that meet the specified criteria. <br> <br>
 * You can retrieve the deleted events through a GDPR access request.
 */
export function bulkDeleteEventsByFilter(payload) {
    var _a = serializer(_bulkDeleteEventsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteEventsByFilterResponse, {}).fromJSON;
    function __bulkDeleteEventsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'POST',
            methodFqn: 'wix.events.events.v3.EventManagement.BulkDeleteEventsByFilter',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/bulk/events/delete-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteEventsByFilter.fromReq = fromReq;
    __bulkDeleteEventsByFilter.__isAmbassador = true;
    return __bulkDeleteEventsByFilter;
}
/**
 * Retrieves a list of events, with the specified paging, filtering, and sorting.
 *
 * Query Events runs with these defaults, which you can override:
 * - `createdDate` is sorted in `ASC` order
 * - `paging.limit` is `0`
 * - `paging.offset` is `0`
 * <br> <br>
 * For field support for filters and sorting, see [Events v3: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/filter-and-sort).
 * To learn about working with _Query_ methods, see [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language), [Sorting and Paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging), and [Field Projection](https://dev.wix.com/docs/rest/articles/get-started/field-projection).
 * <br>
 * >**Note:** You need to pass the `paging` field in the request to get the items in the response.
 */
export function queryEvents(payload) {
    var _a = serializer(_queryEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryEventsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __queryEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'POST',
            methodFqn: 'wix.events.events.v3.EventManagement.QueryEvents',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryEvents.fromReq = fromReq;
    __queryEvents.__isAmbassador = true;
    return __queryEvents;
}
/**
 * Counts events by status.
 *
 * For field support for filters and sorting, see [Events v3: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/filter-and-sort).
 * To learn about working with _Query_ methods, see [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language), [Sorting and Paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging), and [Field Projection](https://dev.wix.com/docs/rest/articles/get-started/field-projection).
 */
export function countEventsByStatus(payload) {
    var _a = serializer(_countEventsByStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countEventsByStatusResponse, {}).fromJSON;
    function __countEventsByStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'POST',
            methodFqn: 'wix.events.events.v3.EventManagement.CountEventsByStatus',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/count-by-status',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countEventsByStatus.fromReq = fromReq;
    __countEventsByStatus.__isAmbassador = true;
    return __countEventsByStatus;
}
/** Retrieves a list of up to 100 events that belong to the same event category. */
export function listEventsByCategory(payload) {
    var _a = serializer(_listEventsByCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEventsByCategoryResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __listEventsByCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'GET',
            methodFqn: 'wix.events.events.v3.EventManagement.ListEventsByCategory',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/category/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEventsByCategory.fromReq = fromReq;
    __listEventsByCategory.__isAmbassador = true;
    return __listEventsByCategory;
}
/** Retrieves an event by ID. */
export function getEvent(payload) {
    var _a = serializer(_getEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEventResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __getEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'GET',
            methodFqn: 'wix.events.events.v3.EventManagement.GetEvent',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/{eventId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEvent.fromReq = fromReq;
    __getEvent.__isAmbassador = true;
    return __getEvent;
}
/**
 * Retrieves an event by the slug URL.
 *
 * The slug is the end of an event URL that refers to a specific event. For example, if an event's URL is `https://example.com/events/event/{my-event-slug}`, the slug is `my-event-slug`.
 */
export function getEventBySlug(payload) {
    var _a = serializer(_getEventBySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEventBySlugResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __getEventBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'GET',
            methodFqn: 'wix.events.events.v3.EventManagement.GetEventBySlug',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/slug/{slug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEventBySlug.fromReq = fromReq;
    __getEventBySlug.__isAmbassador = true;
    return __getEventBySlug;
}
/**
 * Finds an event by ID or URL slug.
 *
 * The difference between Get Event and this method, is that Get Event returns the `"Not found error"`, while Find Event returns an empty response when the event isn't found.
 */
export function findEvent(payload) {
    var _a = serializer(_findEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_findEventResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _badgeList: _badgeList,
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _dateAndTimeSettings: _dateAndTimeSettings,
        _design: _design,
        _event: _event,
        _eventCategories: _eventCategories,
        _eventCategory: _eventCategory,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _location: _location,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _occurrence: _occurrence,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _recurrences: _recurrences,
        _registration: _registration,
        _richContent: _richContent,
        _rsvpRegistration: _rsvpRegistration,
        _v3Badge: _v3Badge,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __findEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.event',
            method: 'GET',
            methodFqn: 'wix.events.events.v3.EventManagement.FindEvent',
            url: resolveWixEventsEventsV3EventManagementUrl({
                protoPath: '/v3/events/event/find',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __findEvent.fromReq = fromReq;
    __findEvent.__isAmbassador = true;
    return __findEvent;
}
//# sourceMappingURL=http.impl.js.map